"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isEwcCodesLoaded = isEwcCodesLoaded;
exports.isTransportDocumentsLoaded = isTransportDocumentsLoaded;
exports.loadEwcCodes = loadEwcCodes;
exports.loadTransportDocuments = loadTransportDocuments;
exports.loadAnonTransportDocument = loadAnonTransportDocument;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD_TRANSPORT_DOCUMENT = "maaporssi/transportDocuments/LOAD_TRANSPORT_DOCUMENT";
var LOAD_TRANSPORT_DOCUMENT_SUCCESS = "maaporssi/transportDocuments/LOAD_TRANSPORT_DOCUMENT_SUCCESS";
var LOAD_TRANSPORT_DOCUMENT_FAIL = "maaporssi/transportDocuments/LOAD_TRANSPORT_DOCUMENT_FAIL";

var LOAD_EWC_CODES = "maaporssi/transportDocuments/LOAD_EWC_CODES";
var LOAD_EWC_CODES_SUCCESS = "maaporssi/transportDocuments/LOAD_EWC_CODES_SUCCESS";
var LOAD_EWC_CODES_FAIL = "maaporssi/transportDocuments/LOAD_EWC_CODES_FAIL";

var initialState = {
  ewcCodesLoaded: false,
  transportDocumentsLoaded: false,
  transportDocuments: []
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD_EWC_CODES:
      return (0, _extends3.default)({}, state, {
        ewcCodesLoading: true
      });
    case LOAD_EWC_CODES_FAIL:
      return (0, _extends3.default)({}, state, {
        ewcCodesLoading: false,
        ewcCodesLoaded: true,
        error: action.error.error
      });
    case LOAD_EWC_CODES_SUCCESS:
      return (0, _extends3.default)({}, state, {
        ewcCodesLoading: false,
        ewcCodesLoaded: true,
        ewcCodes: action.result
      });
    case LOAD_TRANSPORT_DOCUMENT:
      return (0, _extends3.default)({}, state, {
        transportDocumentsLoading: true,
        transportDocumentsError: null,
        transportDocumentsSuccess: false
      });
    case LOAD_TRANSPORT_DOCUMENT_FAIL:
      return (0, _extends3.default)({}, state, {
        transportDocumentsLoading: false,
        transportDocumentsLoaded: true,
        transportDocumentsError: action.error.error
      });
    case LOAD_TRANSPORT_DOCUMENT_SUCCESS:
      var result = Array.isArray(action.result) ? action.result : [action.result];
      var transportDocuments = result.map(function (transportDocument) {
        var loadedTransportDocument = state.transportDocuments && state.transportDocuments.find(function (stateTransportDocument) {
          return stateTransportDocument.isTransportDocumentsLoaded && stateTransportDocument.id === transportDocument.id;
        });
        return loadedTransportDocument || transportDocument;
      });
      return (0, _extends3.default)({}, state, {
        transportDocumentsLoading: false,
        transportDocumentsLoaded: true,
        transportDocumentsError: null,
        transportDocuments: transportDocuments
      });
    default:
      return state;
  }
}
function isEwcCodesLoaded(globalState) {
  return globalState.transporDocuments && globalState.transporDocuments.ewcCodesLoaded;
}

function isTransportDocumentsLoaded(globalState) {
  return globalState.transportDocuments && globalState.transportDocuments.transportDocumentsLoaded;
}

function loadEwcCodes() {
  return {
    types: [LOAD_EWC_CODES, LOAD_EWC_CODES_SUCCESS, LOAD_EWC_CODES_FAIL],
    promise: function promise(client) {
      return client.get("/ewc_codes");
    }
  };
}

function loadTransportDocuments(user) {
  return {
    types: [LOAD_TRANSPORT_DOCUMENT, LOAD_TRANSPORT_DOCUMENT_SUCCESS, LOAD_TRANSPORT_DOCUMENT_FAIL],
    promise: function promise(client) {
      if (user.is_driver) {
        return client.get("users/" + user.id + "/transport_documents");
      }
      return client.get("companies/" + user.company_id + "/transport_documents");
    }
  };
}

function loadAnonTransportDocument(token) {
  return {
    types: [LOAD_TRANSPORT_DOCUMENT, LOAD_TRANSPORT_DOCUMENT_SUCCESS, LOAD_TRANSPORT_DOCUMENT_FAIL],
    promise: function promise(client) {
      return client.get("/transport_documents/token/" + token);
    }
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/transportDocuments.js
 ** module id = 311
 ** module chunks = 0
 **/